

































import {
    computed,
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';
import {
    SdsAlert,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import {
    useI18n,
    isMobileLayout,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import SdsPageHeader from '@shared/components/pageHeader/SdsPageHeader.vue';
import { capitalize } from '@superbet-group/web.lib.utilities';
import { Link } from '@src/app/router/constants/Link';
import AccountSecurityBanner from '@accountFederation/modules/securityCheck/faceId/components/AccountSecurityBanner.vue';
import authenticationStore from '@store/modules/data/authentication/authenticationIndex';

export default defineComponent({
    name: 'AccountSecurityContainer',
    setup() {
        const { translate } = useI18n();
        const errorMessage = ref<string>('');
        const authModule = useVuexStore<typeof authenticationStore>('data/authentication');
        const hasVisitedAcountSecurity = authModule.getter('hasVisitedAccountSecurity');

        onMounted(() => {
            if (!hasVisitedAcountSecurity.value) {
                const setHasVsitedAccountSecurity = authModule.action('setHasVisitedAccountSecurity');
                setHasVsitedAccountSecurity(true);
            }
        });

        return {
            errorMessage,
            isMobile: computed(() => isMobileLayout()),
            breadcrumbs: [
                {
                    label: capitalize(translate('settings')),
                    to: Link.Account.Settings,
                },
            ],
        };
    },
    components: {
        SdsAlert,
        SdsIcon,
        SdsPageHeader,
        AccountSecurityBanner,
    },
});
